import type { IconSvgObject } from './types';

const Notebook01Icon: IconSvgObject = [
  ["path", { d: "M6 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 10H17.5V6H9.5V10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 6L2 6M6 12H2M6 18H2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Notebook01Icon;
